import { PublicApiClient } from "../../apiClient/publicApiClient";

interface UploadMediaOptions {
    callId: string;
    files: File[];
    apiClient: PublicApiClient;
}

export const uploadMedia = async ({ callId, files, apiClient }: UploadMediaOptions): Promise<unknown[]> => {
    return Promise.all(
        files.map((file) => {
            return apiClient.request("/servicecall/uploadmedia", {
                headers: {
                    CallId: callId,
                    Accept: "application/json",
                    "Content-Type": file.type,
                    FileName: file.name
                },
                body: file,
                method: "POST",
                binary: true
            });
        })
    );
};
